// homeViewNew arrives from the API as an array of one JSON string.
// Some sheets are stored encoded twice (the test house): parse until we get the list of sections.
export function parseHomeView(data) {
    let value = Array.isArray(data) ? data[0] : data
    while (typeof value === "string") value = JSON.parse(value)
    if (!Array.isArray(value)) throw new Error("Fiche Home illisible")
    return value
}
